import { Modal, ModalBody } from "reactstrap";
import { Box, Button } from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { userStatusModalStyles } from "./styles";
import { APP_BACKGROUND_COLOR } from "../../theme";

const UserStatusModal: React.FC<{
  userId: string;
  userVerified?: boolean;
  targetPage: string;
}> = ({ userId, userVerified, targetPage }) => {
  const { loginWithRedirect } = useAuth0();
  const navigate = useNavigate();
  return (
    <Modal
      sx={{ backgroundColor: APP_BACKGROUND_COLOR, color: "white" }}
      isOpen={userId === "" || (!userVerified && userVerified !== undefined)}
      centered
      contentClassName={"no-border"}
    >
      <Box sx={userStatusModalStyles.headingContainer}>
        <h4 style={userStatusModalStyles.heading}>
          {userId === ""
            ? "Please Login or Sign Up"
            : "Verification is Going on..."}
        </h4>
        <hr />
      </Box>
      <Box sx={{ backgroundColor: APP_BACKGROUND_COLOR, color: "white" }}>
        <ModalBody
          sx={{ backgroundColor: APP_BACKGROUND_COLOR, color: "white" }}
        >
          <Box sx={userStatusModalStyles.modalBodyContainer}>
            <p
              style={{ backgroundColor: APP_BACKGROUND_COLOR, color: "white" }}
            >
              {userId === ""
                ? ""
                : " We are currently in the process of approving your OmMuse account - you should have access to Daw within 24 hours."}
            </p>
            <Button
              sx={userStatusModalStyles.loginSignUpButton}
              onClick={() => {
                userId === ""
                  ? loginWithRedirect({
                      appState: {
                        targetUrl: targetPage,
                      },
                    })
                  : navigate("/explore");
              }}
            >
              {userId === "" ? "Signup / Login" : "Explore Music"}
            </Button>
          </Box>
        </ModalBody>
      </Box>
    </Modal>
  );
};

export default UserStatusModal;
